import script from "./BudgetApprovalPage.vue?vue&type=script&setup=true&lang=js"
export * from "./BudgetApprovalPage.vue?vue&type=script&setup=true&lang=js"

import "./BudgetApprovalPage.vue?vue&type=style&index=0&id=29d6bc2e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29d6bc2e"]])

export default __exports__